<template>
  <div class="languages">
    <!-- <h3 class="f18">
            {{ localStorage.translations.pages.setting.pages['yazyk-interfeysa'] }}
        </h3> -->
    <!-- <transition name="fade" mode="out-in" appear> -->
    <div class="languages__grid">
      <div
        class="languages__button"
        :class="{ active: languageSelect.id === lang.id }"
        v-for="(lang, key) in languagesSort(languages)"
        :key="key"
        @click="onLanguageChange(lang, key)"
      >
        <div class="languages__button_left">
          <img :src="lang.image.svg" alt="" />
          <span class="languages__button__text f20">{{ lang.name }}</span>
        </div>
        <div class="languages__button__indicator"></div>
      </div>
    </div>
    <BaseButton
      :disabled="$cookies.get('languageSelect').id == languageSelect.id"
      :text="localStorage.translations.pages.common.buttons['sohranit']"
      @click="saveChange"
      default_icon="button-save"
    />
    <LoadingAnimation v-if="loadingAnimation" />

    <!-- </transition> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LoadingAnimation from 'components/LoadingAnimation'

export default {
  name: 'LanguagesChange',
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      languageSelect: null,
    }
  },
  created() {
    if ($cookies.get('languageSelect')) {
      this.languageSelect = $cookies.get('languageSelect')
    }
  },
  computed: {
    ...mapGetters('languages', ['languages']),
    ...mapGetters(['loadingAnimation', 'apiDomain', 'checkUseProtocol']),
  },
  methods: {
    ...mapActions('user', ['CHANGE_userLanguage']),
    onLanguageChange(lang, key) {
      this.languageSelect = lang
      this.languageSelect.key = key
    },
    async saveChange() {
      $cookies.set(
        'languageSelect',
        this.languageSelect,
        '1y',
        null,
        null,
        this.checkUseProtocol,
        'Strict',
      )
      await this.CHANGE_userLanguage()
      this.$router.go(0)
    },
    languagesSort(languages) {
      return Object.keys(languages)
        .sort(function (x, y) {
          return x == $cookies.get('languageSelect').key
            ? -1
            : y == $cookies.get('languageSelect').key
            ? 1
            : 0
        })
        .reduce(function (Obj, key) {
          Obj[key] = languages[key]
          return Obj
        }, {})
    },
  },
}
</script>

<style lang="scss" scoped>
.languages {
  &__grid {
    // margin-top: 30px;
    display: grid;
    grid-template-columns: repeat(auto-fill, 280px);
    gap: 24px;
    margin-bottom: 30px;
  }
  &__button {
    background: #ffffff;
    border-radius: 4px;
    padding: 20px 29px 20px 20px;
    align-items: center;
    align-content: center;
    cursor: pointer;
    transition: 0.3s;
    display: flex;
    justify-content: space-between;
    column-gap: 20px;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid #bedbeb;
      object-fit: cover;
    }
    &_left {
      display: grid;
      grid-template-columns: max-content auto;
      align-items: center;
      column-gap: 28px;
    }
    &__text {
      text-transform: capitalize;
    }
    &__indicator {
      width: 24px;
      height: 24px;
      border: 1px solid #16558f;
      border-radius: 50%;
      position: relative;
      &::before {
        content: '';
        transition: 0.3s;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 62%;
        height: 62%;
        border-radius: 50%;
        background: #16558f;
        opacity: 0;
      }
    }
    &:hover {
      box-shadow: 0px 0px 16px rgba(67, 142, 184, 0.4);
    }
    &.active {
      .languages__button__indicator {
        &::before {
          opacity: 1;
        }
      }
    }
  }
}
</style>
